"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLine = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _Theme = require("../../Theme/Theme.media");

var _Theme2 = require("../../Theme/Theme.spacing");

var _Theme3 = require("../../Theme/Theme.display");

var _Theme4 = require("../../Theme/Theme.variables");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      background-color: ", ";\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      height: 2px;\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      width: 32px;\n      margin-top: 16px;\n      margin-bottom: 16px;\n      @media (min-width: ", ") {\n        margin-top: 32px;\n        margin-bottom: 32px;\n      }\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  /* Spacing */\n  margin: 0;\n  border: 0;\n  height: 1px;\n  background-color: ", ";\n\n  /* Dynamic Spacing */\n  ", ";\n\n  /* Headline Divider */\n  ", ";\n\n  /* border */\n  ", "\n\n\n  /* Color */\n  ", ";\n\n  ", ";\n  \n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var StyledLine = _styledComponents.default.hr(_templateObject(), function (props) {
  return (0, _Theme4.variables)(props).gray;
}, function (props) {
  return (0, _Theme2.spacing)(props);
}, function (props) {
  return props.headlineDivider && (0, _styledComponents.css)(_templateObject2(), (0, _Theme4.variables)(props).breakpoints['xs']);
}, function (props) {
  return props.strong && (0, _styledComponents.css)(_templateObject3());
}, function (props) {
  return props.lineColor && (0, _styledComponents.css)(_templateObject4(), (0, _Theme4.variables)(props)[props.lineColor]);
}, _styledSystem.space);

exports.StyledLine = StyledLine;